// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  min-height: 100vh;
}
body {
  margin: 0;
}
.nkl-deck-app-root-outer {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.nkl-deck-app-root {
  padding-top: 50px;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  font-family: Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}
@media screen and (max-width: 735px) {
  .nkl-deck-app-root {
    padding-top: 0;
  }
}
.nkl-deck-app-root.nkl-deck-app-root-admin {
  padding-top: 100px;
}
@media screen and (max-width: 735px) {
  .nkl-deck-app-root.nkl-deck-app-root-admin {
    padding-top: 50px;
  }
}
.nkl-deck-app-root .ant-drawer-mask {
  z-index: 30;
}
.nkl-deck-app-root .nkl-content-root {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 24px;
}
@media screen and (max-width: 735px) {
  .nkl-deck-app-root .nkl-content-root {
    padding-top: 100px;
  }
}
.nkl-deck-app-root .nkl-content-root .ant-layout-content {
  margin: 0;
  padding: 0;
}
@media screen and (max-width: 735px) {
  .nkl-deck-app-root .nkl-content-root .ant-layout-content {
    margin: 0;
  }
}
.nkl-deck-app-root.ant-layout-has-sider.ant-layout {
  flex-direction: column;
}
.nkl-deck-app-root.ant-layout-has-sider.ant-layout .nkl-deck-site-content {
  padding-left: 320px;
  background-color: #F5F7FA;
}
.nkl-deck-app-root.ant-layout-has-sider.ant-layout .nkl-deck-site-content .ant-drawer {
  z-index: 1001;
  font-family: Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}
.nkl-deck-app-root.ant-layout-has-sider.ant-layout .nkl-deck-site-content .ant-drawer:not(.main-drawer) {
  top: 100px;
}
.nkl-deck-app-root.ant-layout-has-sider.ant-layout .nkl-deck-site-content .ant-drawer.ant-drawer-left .ant-drawer-body {
  padding-top: 0;
}
.nkl-deck-app-root .ant-layout-sider {
  animation-duration: 0s;
  overflow: auto;
}
@media screen and (max-width: 735px) {
  .nkl-deck-app-root .ant-layout-sider.open {
    z-index: 1002;
    top: 100px;
  }
  .nkl-deck-app-root .ant-layout-sider.collapsed {
    z-index: 1002;
    top: 100px;
  }
}
.nkl-deck-app-root.nkl-deck-app-root-admin .ant-layout-sider.open {
  top: 100px;
}
.nkl-deck-app-root.nkl-deck-app-root-admin .ant-layout-sider.collapsed {
  top: 100px;
}
@media screen and (max-width: 735px) {
  .nkl-deck-app-root.nkl-deck-app-root-admin .ant-layout-sider.open {
    top: 150px;
  }
  .nkl-deck-app-root.nkl-deck-app-root-admin .ant-layout-sider.collapsed {
    top: 150px;
  }
}
@media screen and (max-width: 1407px) {
  .nkl-deck-app-root.ant-layout-has-sider.ant-layout .nkl-deck-site-content {
    padding-left: 0;
  }
  .nkl-deck-app-root.ant-layout-has-sider.ant-layout .ant-layout-sider {
    height: 100%;
    position: fixed;
    box-shadow: 0px 16px 48px rgba(52, 56, 63, 0.24);
  }
  .nkl-deck-app-root.ant-layout-has-sider.ant-layout .ant-layout-sider.collapsed {
    left: -320px;
    transition: left ease-in-out 300ms;
    box-shadow: none;
  }
  .nkl-deck-app-root.ant-layout-has-sider.ant-layout .ant-layout-sider.open {
    left: 0;
  }
}
@media screen and (min-width: 1407px) {
  .nkl-deck-app-root .nkl-deck-site-content .ant-layout-sider {
    left: 0px;
    transition: left ease-in-out 300ms;
  }
}
.nkl-deck-app-root .ant-layout-sider {
  left: -320px;
  transition: left ease-in-out 300ms;
  position: fixed;
  z-index: 1002;
  top: 50px;
  height: 100%;
}
.nkl-deck-app-root.nkl-deck-no-header {
  padding-top: 0;
}
.nkl-deck-app-root.nkl-deck-no-header .nkl-deck-site-content {
  padding-left: 0;
}
.nkl-deck-app-root.antd-layout-has-sider {
  flex-direction: column;
}
.nkl-deck-app-root.nkl-deck-no-leftNav .ant-layout-content {
  margin-left: 0;
}
.nkl-deck-site-content {
  flex: 1 1 auto;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
